'use strict';

var _objectSpread = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _createForOfIteratorHelper = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _objectWithoutProperties = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

let Declaration = require('./declaration');

let PreviousMap = require('./previous-map');

let Comment = require('./comment');

let AtRule = require('./at-rule');

let Input = require('./input');

let Root = require('./root');

let Rule = require('./rule');

function fromJSON(json, inputs) {
  if (Array.isArray(json)) return json.map(n => fromJSON(n));

  let ownInputs = json.inputs,
      defaults = _objectWithoutProperties(json, ["inputs"]);

  if (ownInputs) {
    inputs = [];

    var _iterator = _createForOfIteratorHelper(ownInputs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let input = _step.value;

        let inputHydrated = _objectSpread(_objectSpread({}, input), {}, {
          __proto__: Input.prototype
        });

        if (inputHydrated.map) {
          inputHydrated.map = _objectSpread(_objectSpread({}, inputHydrated.map), {}, {
            __proto__: PreviousMap.prototype
          });
        }

        inputs.push(inputHydrated);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(n => fromJSON(n, inputs));
  }

  if (defaults.source) {
    let _defaults$source = defaults.source,
        inputId = _defaults$source.inputId,
        source = _objectWithoutProperties(_defaults$source, ["inputId"]);

    defaults.source = source;

    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }

  if (defaults.type === 'root') {
    return new Root(defaults);
  } else if (defaults.type === 'decl') {
    return new Declaration(defaults);
  } else if (defaults.type === 'rule') {
    return new Rule(defaults);
  } else if (defaults.type === 'comment') {
    return new Comment(defaults);
  } else if (defaults.type === 'atrule') {
    return new AtRule(defaults);
  } else {
    throw new Error('Unknown node type: ' + json.type);
  }
}

module.exports = fromJSON;
fromJSON.default = fromJSON;